import React from "react";
import "./Apps.scss";
import UtilServices from "@services/UtilServices";
import MessageServices from "@services/MessageServices";

export default function Apps(props) {
  return (
    <div className="apps">
      <div className="apps-b">
        <div
          className={`apps-icons ${props.disabled ? "disabled" : ""}`}
          onClick={() => {
            if (!props.disabled) {
              props.onClick(); // Executa a função passada como props
              props.setOpenApps(false);
            } else {
              MessageServices.ShowWarning(
                "Você não tem acesso a este app. Entre em contato para contratá-lo.",
              );
            }
          }}
          data-tooltip-id="tooltip-001"
          data-tooltip-content={props.title}
          style={{ backgroundColor: props?.background }}
        >
          <div>
            {props?.tpIcon === "svg"
              ? props.icon
              : UtilServices.stringToJsx(props.icon)}
          </div>
        </div>
        <p className={`apps-desc ${props.disabled ? "disabled" : ""}`}>
          {props.desc}
        </p>
      </div>
    </div>
  );
}

Apps.defaultProps = {
  className: "",
  icon: "<i class='fa-thin fa-coin'></i>",
  tpIcon: null,
  desc: "Cobrança",
  disabled: false,
  onClick: () => null,
  background: "#373148",
};
